import api from "../../../../api/axios";

const BASE = "/tiposoperacao";
const DEFAULT_LIST_LIMIT = 5000;

function mapRow(row = {}) {
  return {
    ...row,
    motivo: row?.tipo_operacao ?? row?.motivo ?? "",
  };
}

export async function listarTiposOperacao({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  const rows = Array.isArray(data?.data) ?data.data.map(mapRow) : [];
  return {
    rows,
    meta: data?.meta || { limit, offset },
  };
}

export async function cadastrarTipoOperacao(payload) {
  const { data } = await api.post(`${BASE}/cadastrar`, {
    tipo_operacao: payload?.motivo ?? "",
  });
  return data;
}

export async function editarTipoOperacao(id, payload) {
  const { data } = await api.put(`${BASE}/editar/${id}`, {
    tipo_operacao: payload?.motivo ?? "",
  });
  return data;
}

export async function alterarStatusTipoOperacao(id, ativo) {
  const { data } = await api.patch(`${BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ?1 : 0,
  });
  return data;
}

export async function excluirTipoOperacao(id) {
  const { data } = await api.delete(`${BASE}/excluir/${id}`);
  return data;
}
